var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_337_8954)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00003 2.57138C3.6331 2.57138 1.71432 4.49016 1.71432 6.85709C1.71432 9.22403 3.6331 11.1428 6.00003 11.1428C8.36697 11.1428 10.2857 9.22403 10.2857 6.85709C10.2857 4.49016 8.36697 2.57138 6.00003 2.57138ZM0.857178 6.85709C0.857178 4.01677 3.15971 1.71423 6.00003 1.71423C8.84036 1.71423 11.1429 4.01677 11.1429 6.85709C11.1429 9.69741 8.84036 11.9999 6.00003 11.9999C3.15971 11.9999 0.857178 9.69741 0.857178 6.85709Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.94968 0.227037C3.06097 0.435938 2.98183 0.695499 2.77293 0.806783C2.00549 1.21561 1.32069 1.76345 0.753371 2.42243C0.598945 2.60181 0.328343 2.62204 0.148965 2.46761C-0.0304122 2.31319 -0.0506394 2.04258 0.103787 1.86321C0.740371 1.12377 1.50879 0.509027 2.36994 0.0502853C2.57884 -0.0609988 2.8384 0.0181354 2.94968 0.227037Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.05035 0.227037C9.16163 0.0181354 9.42119 -0.0609988 9.63009 0.0502853C10.4912 0.509027 11.2597 1.12377 11.8962 1.86321C12.0507 2.04258 12.0304 2.31319 11.8511 2.46761C11.6717 2.62204 11.4011 2.60181 11.2467 2.42243C10.6793 1.76345 9.99454 1.21561 9.2271 0.806783C9.0182 0.695499 8.93906 0.435938 9.05035 0.227037Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99998 3.85706C6.23668 3.85706 6.42855 4.04893 6.42855 4.28563V6.42848H8.14284C8.37953 6.42848 8.57141 6.62036 8.57141 6.85706C8.57141 7.09375 8.37953 7.28563 8.14284 7.28563H5.99998C5.76329 7.28563 5.57141 7.09375 5.57141 6.85706V4.28563C5.57141 4.04893 5.76329 3.85706 5.99998 3.85706Z",
    fill: "#000001"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_337_8954"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockAlarm);
export default __webpack_public_path__ + "static/media/clock-alarm.3e31cd18b5217f101893893dc91a5618.svg";
export { ForwardRef as ReactComponent };